import { MutableRefObject, useCallback } from 'react';
import { useTemplateEditorDispatch } from '../context/UseTemplateEditorContext';
import { useLocation } from 'react-router';
import {
  IOffsiteTemplatePreviewResponse,
  OnsiteTemplatePreviewQueryResponse,
} from 'sections/design/template-management/entities/templates';

export const useUpdateTemplate = (
  isPreviewButtonClicked: MutableRefObject<boolean>,
  response: IOffsiteTemplatePreviewResponse | OnsiteTemplatePreviewQueryResponse,
) => {
  const { pathname } = useLocation();
  const isOnsiteTemplate = pathname.includes('onsite');

  const dispatch = useTemplateEditorDispatch();

  return useCallback(() => {
    if (isPreviewButtonClicked.current && !isOnsiteTemplate) {
      dispatch({
        type: 'UPDATE_TEMPLATE',
        payload: {
          precompiledTemplate: (response as IOffsiteTemplatePreviewResponse).precompiled,
        },
      });
    }
  }, [isPreviewButtonClicked, isOnsiteTemplate, dispatch, response]);
};
